define('OutSystems/ClientRuntime/Public',["require", "exports", "./Application", "./ApplicationInfo", "./BuiltinFunctions", "./Controller", "./FeedbackMessageService", "./Injector", "./Injector/KnownServices", "./Logger", "./NativeHelper", "./Navigation", "./ResourceCache", "./RolesService", "./Transitions", "./VersionsManager"], function (require, exports, Application_1, ApplicationInfo, ImportedBuiltinFunctions, Controller_1, FeedbackMessageService, Injector, KnownServices_1, LoggerModule, NativeHelper_1, NavigationModule, ResourceCache_1, RolesService, Transitions, VersionsManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Branding = exports.ApplicationLoad = exports.ApplicationContext = exports.View = exports.Logger = exports.Navigation = exports.ApplicationLifecycle = exports.Device = exports.Validation = exports.FeedbackMessage = exports.FeedbackMessageType = exports.Security = exports.BuiltinFunctions = void 0;
    function emitDeprecatedWarning(oldUsage, newUsage) {
        LoggerModule.log("Public", "'" + oldUsage + "' is deprecated and will be removed on the next version. Consider using '" + newUsage + "' instead.");
    }
    function getCurrentModelContext() {
        return Controller_1.BaseViewController.activeScreen
            ? Controller_1.BaseViewController.activeScreen.modelContext
            : { viewName: "", navigatedFromHistory: false, viewWasRestoredFromCache: false };
    }
    exports.BuiltinFunctions = ImportedBuiltinFunctions;
    var Security;
    (function (Security) {
        function checkIfCurrentUserHasRole(roleKey) {
            return RolesService.checkRole(roleKey);
        }
        Security.checkIfCurrentUserHasRole = checkIfCurrentUserHasRole;
    })(Security = exports.Security || (exports.Security = {}));
    var FeedbackMessageType;
    (function (FeedbackMessageType) {
        FeedbackMessageType[FeedbackMessageType["Info"] = 0] = "Info";
        FeedbackMessageType[FeedbackMessageType["Success"] = 1] = "Success";
        FeedbackMessageType[FeedbackMessageType["Warning"] = 2] = "Warning";
        FeedbackMessageType[FeedbackMessageType["Error"] = 3] = "Error";
    })(FeedbackMessageType = exports.FeedbackMessageType || (exports.FeedbackMessageType = {}));
    var FeedbackMessage;
    (function (FeedbackMessage) {
        function convertFeedbackMessageTypeToInternalEnum(type) {
            switch (type) {
                case FeedbackMessageType.Info:
                    return 0;
                case FeedbackMessageType.Success:
                    return 1;
                case FeedbackMessageType.Warning:
                    return 2;
                case FeedbackMessageType.Error:
                    return 3;
                default:
                    throw new Error("Don't know how to convert " + type);
            }
        }
        function showFeedbackMessage(message, messageType, encodeHTML, extraCssClasses, closeOnClick, onClick) {
            if (encodeHTML === void 0) { encodeHTML = true; }
            if (closeOnClick === void 0) { closeOnClick = true; }
            return FeedbackMessageService.showFeedbackMessage(message, convertFeedbackMessageTypeToInternalEnum(messageType), encodeHTML, extraCssClasses, closeOnClick, onClick);
        }
        FeedbackMessage.showFeedbackMessage = showFeedbackMessage;
        function closeFeedbackMessage() {
            return FeedbackMessageService.closeFeedbackMessage();
        }
        FeedbackMessage.closeFeedbackMessage = closeFeedbackMessage;
    })(FeedbackMessage = exports.FeedbackMessage || (exports.FeedbackMessage = {}));
    var Validation = (function () {
        function Validation(_model) {
            this._model = _model;
        }
        Validation.prototype.setWidgetAsInvalid = function (widgetId, validationMessage) {
            var validationRecord = this._model.widgets.get(widgetId);
            validationRecord.validAttr = false;
            validationRecord.validationMessageAttr = validationMessage;
        };
        Validation.prototype.setWidgetAsValid = function (widgetId) {
            var validationRecord = this._model.widgets.get(widgetId);
            validationRecord.validAttr = true;
            validationRecord.validationMessageAttr = "";
        };
        Validation.prototype.isWidgetValid = function (widgetId) {
            var validationRecord = this._model.widgets.get(widgetId);
            return validationRecord.validAttr === true;
        };
        return Validation;
    }());
    exports.Validation = Validation;
    var Device;
    (function (Device) {
        function whenReady() {
            return NativeHelper_1.whenDeviceReady;
        }
        Device.whenReady = whenReady;
    })(Device = exports.Device || (exports.Device = {}));
    var ApplicationLifecycle;
    (function (ApplicationLifecycle) {
        function isUpgradingVersion() {
            return VersionsManager_1.default.isUpgradingVersion;
        }
        ApplicationLifecycle.isUpgradingVersion = isUpgradingVersion;
        function listen(eventHandlers) {
            LoggerModule.trace("ApplicationLifecycle", "Registering listeners for the application load process.");
            if (!eventHandlers) {
                return;
            }
            if (eventHandlers.onLoadComplete) {
                Application_1.default.waitForAppReady().then(function () { return eventHandlers.onLoadComplete(); });
            }
            if (eventHandlers.onUpgradeProgress) {
                ResourceCache_1.ResourceCache.listen(null, null, function (loaded, total) { return eventHandlers.onUpgradeProgress(loaded, total); });
            }
        }
        ApplicationLifecycle.listen = listen;
    })(ApplicationLifecycle = exports.ApplicationLifecycle || (exports.ApplicationLifecycle = {}));
    var Navigation = (function () {
        function Navigation(_context) {
            this._context = _context;
        }
        Navigation.prototype.navigateTo = function (url, transition, replace) {
            NavigationModule.navigateTo(url, this.getTransitionObject(transition, Transitions.Default), this._context, false, replace);
        };
        Navigation.prototype.navigateBack = function (transition) {
            NavigationModule.navigateBack(this.getTransitionObject(transition), this._context, false);
        };
        Navigation.prototype.navigateBackNumPages = function (numPages, transition) {
            NavigationModule.navigateBackNumPages(numPages, this.getTransitionObject(transition), this._context, false);
        };
        Navigation.prototype.navigateForward = function (transition) {
            NavigationModule.navigateForward(this.getTransitionObject(transition), this._context, false);
        };
        Navigation.prototype.navigateForwardNumPages = function (numPages, transition) {
            NavigationModule.navigateForwardNumPages(numPages, this.getTransitionObject(transition), this._context, false);
        };
        Navigation.prototype.navigatedFromHistory = function () {
            return getCurrentModelContext().navigatedFromHistory;
        };
        Navigation.prototype.registerBackNavigationHandler = function (handlerCallback) {
            return NavigationModule.registerBackNavigationHandler(handlerCallback);
        };
        Navigation.prototype.unregisterBackNavigationHandler = function (id) {
            NavigationModule.unregisterBackNavigationHandler(id);
        };
        Navigation.prototype.getTransitionObject = function (transitionType, defaultTransition) {
            if (defaultTransition === void 0) { defaultTransition = null; }
            return Transitions.createTransition(transitionType, defaultTransition);
        };
        return Navigation;
    }());
    exports.Navigation = Navigation;
    var Logger;
    (function (Logger) {
        function log(module, message) {
            LoggerModule.log(module, message);
        }
        Logger.log = log;
        function error(module, messageOrError, error) {
            LoggerModule.error(module, messageOrError, error);
        }
        Logger.error = error;
    })(Logger = exports.Logger || (exports.Logger = {}));
    var View = (function () {
        function View(_model) {
            this._model = _model;
        }
        Object.defineProperty(View, "ActiveScreenCssClass", {
            get: function () {
                return "active-screen";
            },
            enumerable: false,
            configurable: true
        });
        View.prototype.getCurrentScreenRootElement = function () {
            return document.querySelector("." + View.ActiveScreenCssClass);
        };
        View.prototype.render = function () {
            return new Promise(function (resolve) {
                requestAnimationFrame(function () {
                    setTimeout(resolve, 1);
                });
            });
        };
        View.prototype.wasCurrentViewRestoredFromCache = function () {
            return this._model ? this._model.context.viewWasRestoredFromCache : false;
        };
        View.prototype.registerDeviceClassGetter = function (getter) {
            return Injector.register(KnownServices_1.ServiceNames.DeviceHelperClassProvider, function () { return getter; });
        };
        return View;
    }());
    exports.View = View;
    var ApplicationContext = (function () {
        function ApplicationContext() {
        }
        ApplicationContext.getCurrentScreenDefinition = function () {
            var activeScreen = Controller_1.BaseViewController.activeScreen;
            if (activeScreen) {
                var module = ApplicationInfo.getModuleFromKey(ApplicationInfo.getHomeModuleKey());
                if (module) {
                    return ApplicationInfo.getScreenDefinitionFromScreenName(module, activeScreen.viewName);
                }
            }
            return null;
        };
        ApplicationContext.getCurrentContext = function () {
            var screen = ApplicationContext.getCurrentScreenDefinition();
            return {
                applicationKey: ApplicationInfo.getApplicationKey() || "",
                applicationName: ApplicationInfo.getApplicationName() || "",
                moduleKey: ApplicationInfo.getHomeModuleKey() || "",
                moduleName: ApplicationInfo.getHomeModuleName() || "",
                screenKey: screen ? screen.screenKey : "",
                screenName: screen ? screen.screenName : "",
            };
        };
        return ApplicationContext;
    }());
    exports.ApplicationContext = ApplicationContext;
    var ApplicationLoad = (function () {
        function ApplicationLoad() {
        }
        Object.defineProperty(ApplicationLoad, "Instance", {
            get: function () {
                return ApplicationLoad;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ApplicationLoad, "isUpgradingVersion", {
            get: function () {
                emitDeprecatedWarning("ApplicationLoad.isUpgradingVersion", "ApplicationLifecycle.isUpgradingVersion()");
                return ApplicationLifecycle.isUpgradingVersion();
            },
            enumerable: false,
            configurable: true
        });
        ApplicationLoad.listen = function (eventHandlers) {
            emitDeprecatedWarning("ApplicationLoad.listen()", "ApplicationLifecycle.listen()");
            ApplicationLifecycle.listen(eventHandlers);
        };
        return ApplicationLoad;
    }());
    exports.ApplicationLoad = ApplicationLoad;
    var Branding;
    (function (Branding) {
        function showOutSystemsWatermark() {
            return ApplicationInfo.showWatermark();
        }
        Branding.showOutSystemsWatermark = showOutSystemsWatermark;
    })(Branding = exports.Branding || (exports.Branding = {}));
});
//# sourceMappingURL=Public.js.map;
